import type { SVGProps } from 'react';

export const TooltipQuestionMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="13.8px"
    viewBox="0 0 13.8 13.8"
    width="13.8px"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    {...props}
  >
    <title>{'tooltip question mark'}</title>
    <g>
      <path
        d="M13.8,6.9c0,1.9-0.7,3.5-2,4.9c-1.3,1.3-3,2-4.9,2s-3.5-0.7-4.9-2c-1.3-1.3-2-3-2-4.9
          S0.7,3.4,2,2c1.3-1.3,3-2,4.9-2s3.5,0.7,4.9,2C13.2,3.4,13.8,5,13.8,6.9z M0.8,6.9c0,1.7,0.6,3.1,1.8,4.3C3.8,12.4,5.2,13,6.9,13
          c1.7,0,3.1-0.6,4.3-1.8C12.4,10,13,8.6,13,6.9c0-1.7-0.6-3.1-1.8-4.3C10,1.4,8.6,0.8,6.9,0.8c-1.7,0-3.1,0.6-4.3,1.8
          C1.4,3.8,0.8,5.2,0.8,6.9z M7.6,8.1V8c0-0.4,0.2-0.8,0.5-1.2c0.5-0.6,0.8-1.1,0.8-1.6c0-0.4-0.2-0.8-0.5-1.1
          C8.1,3.8,7.7,3.7,7.1,3.7c-0.7,0-1.2,0.1-1.6,0.4l0.3,1.1c0.2-0.2,0.5-0.3,1-0.3c0.5,0,0.7,0.2,0.7,0.6c0,0.1-0.2,0.5-0.6,1
          c-0.4,0.5-0.5,1-0.5,1.5v0.2H7.6z M7.8,9.5c0-0.3-0.1-0.5-0.2-0.7C7.4,8.6,7.2,8.6,6.9,8.6c-0.3,0-0.5,0.1-0.6,0.3
          C6.1,9,6.1,9.2,6.1,9.5c0,0.3,0.1,0.5,0.2,0.6c0.2,0.2,0.4,0.3,0.6,0.3c0.3,0,0.5-0.1,0.6-0.3C7.7,9.9,7.8,9.7,7.8,9.5z"
      />
    </g>
  </svg>
);
